import AboutUs from "../view/aboutus/AboutUs"
import ContactUs from "../view/contact/ContactUs"
import Gallery from "../view/gallery/Gallery"
import Index from "../view/home/Index"
import ProductListing from "../view/product/ProductListing"

const routes = [
    {
        path: "/",
        element: <Index />
    },
    {
        path: "/home",
        element: <Index />
    },
    {
        path: "/about-us",
        element: <AboutUs />
    },
    {
        path: "/product",
        element: <ProductListing />
    },
    {
        path: "/product/:categoryName",
        element: <ProductListing />
    },
    {
        path: "/product/:categoryName/:subCategoryName",
        element: <ProductListing />
    },
    {
        path: "/gallery",
        element: <Gallery />
    },
    {
        path: "/contact",
        element: <ContactUs />
    },
    {
        path: "*",
        element: <Index />
    }
]

export {
    routes
}